import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IOverlayLoaderStore } from '../../../../../../modules/common/OverlayLoader.store';
import { AnnotationTypesList } from '../components/AnnotationTypesList';
import { IProjectDetailsToolsBl } from '../projectDetailsTools.bl';

export const AnnotationTypesListContainer = observer((): ReactElement => {
  const projectDetailsToolsBl = useInjection(IProjectDetailsToolsBl.$);

  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const { projectId } = useParams<{ projectId: string }>();

  const fetchData = async (): Promise<void> => {
    await projectDetailsToolsBl.getProjectDetailsAnnotationViewAsync(projectId);
  };

  useEffect(() => {
    void fetchData();
  }, [projectId]);

  const handleOrderChangeAsync = async (annotationTypeId: string, index: number): Promise<void> => {
    await projectDetailsToolsBl.changeAnnotationTypeOrderAsync(annotationTypeId, index);
  };

  const usedScopes = projectDetailsToolsBl.store.questions
    .map((q) => q.scopes)
    .reduce((prevValue: string[], currentValue: string[]) => prevValue.concat(currentValue), []);

  const sorted = projectDetailsToolsBl.store.annotationTypes.slice().sort((a, b) => a.order - b.order);
  const withUsage = sorted.map((at) => ({ ...at, isUsedAsScope: usedScopes.includes(at.id) }));

  return (
    <AnnotationTypesList
      list={withUsage}
      onOrderChange={handleOrderChangeAsync}
      isLoading={overlayLoaderStore.isSpinnerVisible('getProjectDetailsAnnotation')}
    />
  );
});
